import { globalGetService, globalPostService, globalPutService, globalExportService } from '../../utils/globalApiServices';
import { checkApiStatus, downloadFileType, getLocalStorageInfo, removeEmptyKey } from '../../utils';
import moment from 'moment';
import { errorCode } from '.'
import { fieldValidation } from '../../utils/formValidation';
import { trackActivity } from '../../utils/mixpanel';
import { displayDateFormatShort, backendDateFormat } from '../../constants';

export function getValuationLogApi(props = {}, id, query = {}) {
  return new Promise(
    function (resolve, reject) {
      globalGetService(`valuation/logs/${id}/`, query)
        .then(response => {
          resolve(response);
        })
    }
  )
}

/** Saved engine valuation log (cards, projections, graph, inputs) */
export function getEngineValuationLogApi(props = {}, id, query = {}) {
  return new Promise(function (resolve) {
    globalGetService(`valuation/engine-valuation/logs/${id}/`, query)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        resolve(error && error.response ? error.response : { data: { statusCode: 500 } });
      });
  })
}

/** Engine valuation form config: defaults, metrics, conditions, field guidance */
export function getEngineValuationFormApi(query = {}) {
  return new Promise(function (resolve) {
    globalGetService(`valuation/engine-valuation/form/`, query)
      .then(response => {
        resolve(response);
      })
  })
}

/** Compute + save engine valuation (create new log) */
export function computeEngineValuationApi(props = {}, data = {}, formState = {}) {
  this.setState({ pageLoader: true });
  globalPostService(`valuation/engine-valuation/compute/`, data)
    .then(response => {
      this.setState({ pageLoader: false });
      if (checkApiStatus(response)) {
        this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        const result = response.data.data || {};
        const logId = result.log_id;
        trackActivity('Log Generated', {
          type: 'Engine Valuation',
          log_id: logId
        });
        if (logId) {
          props.history.push({
            pathname: `/logs/${logId}`,
            state: { engineComputeResult: result, engineFormFlags: formState },
          });
        }
      } else {
        const message = (response && response.data && response.data.message) || 'Engine valuation compute failed.';
        this.props.enqueueSnackbar(message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        trackActivity('Log Generation Failed', {
          source: 'backend',
          type: 'Engine Valuation'
        });
      }
    })
    .catch(() => {
      this.setState({ pageLoader: false });
      this.props.enqueueSnackbar('Engine valuation compute failed.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
    });
}

/** Recompute + update existing engine valuation log */
export function updateEngineValuationLogApi(props = {}, data = {}, formState = {}, getResponseBack) {
  const logId = props.match.params.id;
  this.setState({ pageLoader: true });
  globalPutService(`valuation/engine-valuation/logs/${logId}/`, data)
    .then(response => {
      this.setState({ pageLoader: false });
      if (checkApiStatus(response)) {
        this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        trackActivity('Log Edited', {
          type: 'Engine Valuation',
          log_id: logId
        });
        this.setState({ mode: 'view' });
        if (typeof getResponseBack === 'function') {
          getResponseBack();
        }
      } else {
        trackActivity('Log Edit Failed', {
          source: 'backend',
          type: 'Engine Valuation'
        });
        const message = (response && response.data && response.data.message) || 'Engine valuation update failed.';
        this.props.enqueueSnackbar(message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
      }
    })
    .catch(() => {
      this.setState({ pageLoader: false });
      this.props.enqueueSnackbar('Engine valuation update failed.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
    });
}

export function createValuationLogApi(props = {}, data = {}) {
  this.setState({ pageLoader: true });
  globalPostService(`valuation/initiate/`, data)
    .then(response => {
      this.setState({ pageLoader: false });
      if (checkApiStatus(response)) {
        this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        props.history.push(`/logs/${response.data.data.log_id}`);
        trackActivity('Log Generated', {
          type: 'BV/CMV and Future Base Value',
          log_id: response.data.data.log_id
        })
      } else {
        const message = (response && response.data && response.data.message) || 'Valuation compute failed.';
        this.props.enqueueSnackbar(message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        trackActivity('Log Generation Failed', {
          source: 'backend'
        })
      }
    })
    .catch(() => {
      this.setState({ pageLoader: false });
      this.props.enqueueSnackbar('Valuation compute failed.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
      trackActivity('Log Generation Failed', {
        source: 'backend'
      });
    });
}
export function updateValuationLogApi(props = {}, data = {}, getResponseBack) {
  this.setState({ pageLoader: true });
  globalPutService(`valuation/logs/${this.props.match.params.id}/`, data)
    .then(response => {
      this.setState({ pageLoader: false });
      if (checkApiStatus(response)) {
        this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        props.history.push(`/logs/${response.data.data.log_id}`);
        this.setState({ mode: 'view' })
        trackActivity('Log Edited', {
          type: 'BV/CMV and Future Base Value',
          log_id: props.match.params.id
        });
        getResponseBack();
      } else {
        trackActivity('Log Edit Failed', { source: 'backend' })
        const message = (response && response.data && response.data.message) || 'Valuation update failed.';
        this.props.enqueueSnackbar(message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
      }
    })
    .catch(() => {
      this.setState({ pageLoader: false });
      this.props.enqueueSnackbar('Valuation update failed.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
      trackActivity('Log Edit Failed', { source: 'backend' });
    });
}
export function exportValuationLogApi(props = {}, query = {}, data = {}) {
  this.setState({ pageLoader: true });
  const utility_type_name = data.utility_type == 1 ? 'Base Value' : 'Future Value';
  const crud = this.state.valuationCrud || {};
  // Engine logs have no aircraft_type — old code threw on .name and skipped download
  const assetLabel = (data.aircraft_type && data.aircraft_type.name)
    || (data.engine_type && data.engine_type.name)
    || (crud.aircraft_type && crud.aircraft_type.name)
    || (crud.engine_type && crud.engine_type.name)
    || 'Asset';
  const logId = data.id || data.log_id || props.match.params.id;
  const typePart = query.key ? `_${query.key}` : '';
  globalExportService(`valuation/logs/${props.match.params.id}/`, {
    download: query.extension,
    type: query.key,
    utility_type: 'future_value',
  })
    .then(response => {
      this.setState({ pageLoader: false, query: {}, type: '' });
      trackActivity('Report Exported', {
        type: utility_type_name,
        log_id: props.match.params.id,
        file_type: query.extension,
        report_type: query.key,
      });
      downloadFileType(
        response.data,
        `${logId}_${utility_type_name}_${assetLabel}${typePart}_${moment().format('YYYY-MM-DD')}`,
        query.extension
      );
    })
    .catch(() => {
      this.setState({ pageLoader: false });
      this.props.enqueueSnackbar('Export failed.', {
        variant: 'error',
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    });
}

export function changeLogStatusApi(props, data) {
  this.setState({ pageLoader: true})
  globalPutService(`valuation/update-lock/`, data)
    .then(response => {
      this.setState({ pageLoader: false})
      if (checkApiStatus(response)) {
        this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } })
        this.setState(prevState => ({
            ...prevState,
            valuationCrud:{
                ...prevState.valuationCrud,
                lock_status:data.is_locked,
            },
            mode: data.is_locked ? 'view':prevState.mode
        }))
      } else {
        const message = (response && response.data && response.data.message) || 'Unable to update lock status.';
        this.props.enqueueSnackbar(message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } })
      }
    })
    .catch(() => {
      this.setState({ pageLoader: false });
      this.props.enqueueSnackbar('Unable to update lock status.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
    });
}
